import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';

import { DefaultToastComponent } from './components';

@NgModule({
  declarations:
    [DefaultToastComponent,
    ],
  imports: [
    CommonModule,
    MaterialModule,
  ]
})
export class MessagingModule { }
